import { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  IconButton,
  Alert,
  Box,
  Button,
} from "@mui/material";

import { FaEdit, FaTrash } from "react-icons/fa";
import AddEmployerDialog from "./AddEmployerDialog";
import EditEmployerDialog from "./EditEmployerDialog";
import ConfirmDialog from "../../components/ConfirmDialog";

function EmployerList() {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [selectedEmployer, setSelectedEmployer] = useState(null);

  const fetchEmployers = async () => {
    try {
      const res = await axiosInstance.get("/employers");
      setEmployers(res.data);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployers();
  }, []);

  const handleAddEmployer = (newEmp) => {
    setEmployers([...employers, newEmp]);
  };

  const handleUpdateEmployer = (updatedEmp) => {
    setEmployers(
      employers.map((emp) =>
        emp.userId === updatedEmp.userId ? updatedEmp : emp
      )
    );
  };

  const handleDeleteEmployer = async () => {
    await axiosInstance.delete(`/employers/${selectedEmployer.userId}`);

    setEmployers(
      employers.filter((emp) => emp.userId !== selectedEmployer.userId)
    );

    setOpenDelete(false);
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Employers
      </Typography>

      {/* Add Button - RHS */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button variant="contained" onClick={() => setOpenAdd(true)}>
          Add Employer
        </Button>
      </Box>

      {/* Dialogs */}
      <AddEmployerDialog
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        onSave={fetchEmployers}
      />

      <EditEmployerDialog
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        employer={selectedEmployer}
        onUpdate={fetchEmployers}
      />

      <ConfirmDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDeleteEmployer}
        message={`Are you sure you want to delete ${selectedEmployer?.fullName}?`}
      />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f4f4f4" }}>
              <TableCell>
                <strong>User ID</strong>
              </TableCell>
              <TableCell>
                <strong>Name</strong>
              </TableCell>
              <TableCell>
                <strong>Business Name</strong>
              </TableCell>
              <TableCell>
                <strong>Prefix</strong>
              </TableCell>
              <TableCell>
                <strong>Mobile</strong>
              </TableCell>
              <TableCell>
                <strong>Actions</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {employers.map((emp, index) => (
              <TableRow key={index}>
                <TableCell>{emp.userId}</TableCell>
                <TableCell>{emp.fullName}</TableCell>
                <TableCell>{emp.employerName}</TableCell>
                <TableCell>{emp.prefix}</TableCell>
                <TableCell>{emp.mobile}</TableCell>

                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => {
                      setSelectedEmployer(emp);
                      setOpenEdit(true);
                    }}
                  >
                    <FaEdit />
                  </IconButton>

                  <IconButton
                    color="error"
                    onClick={() => {
                      setSelectedEmployer(emp);
                      setOpenDelete(true);
                    }}
                  >
                    <FaTrash />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {employers.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No employers found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default EmployerList;
